/* eslint-disable */

// 用户反馈
export const appType = {
  '小程序': 'xiaochengxu',
  '公众号': 'gongzhonghao',
};

export const payChannelTypes = {
  none: '-',
  wechat: '平台代收',
  alipay: '平台代收',
  original_wechat: '微信公众号支付',
  weapp: '小程序支付',
  virtual_coin: '积分支付',
};

export const commentState = {
  '内容': 'neirong',
  '时间': 'shijian',
  '昵称': 'nicheng',
};

// 用户管理
export const consume = {
  '所有': '',
  '已消费': 1,
};

export const userRuler = {
  '昵称': 'nicheng',
  '手机号码': 'shoujihaoma'
};

export const linkType = {
  '无链接': 'none',
  '音频': 'audio',
  '视频': 'video',
  '图文': 'article',
  '专栏': 'column',
  '外部链接': 'outLink',
  '表单': 'feedback',
  '问卷': 'survey',
  '直播': 'live',
  '课程': 'course',
  '会员卡': 'member_card'
};

export const orderType = {
  '第一屏': 1,
  '第二屏': 2,
  '第三屏': 3
};

export const contentType = {
  'none': '无链接',
  'video': '视频',
  'audio': '音频',
  'column': '专栏',
  'outLink': '外部链接',
  'feedback': '表单',
  'survey': '问卷',
  'article': '图文',
  'live': '直播',
  'course': '课程',
  'exam': '测验',
  'member_card': '会员卡',
  'membercard': '会员卡',
  'promotion': '推广员',
  'fight_group': '拼团',
  'limit_purchase': '限时购',
  'class': '内容分类',
  'community': '小社群',
  'promoter': '推广员',
  'offline_course': '在线招生',
  'offlinecourse': '在线招生',
  'card': '打卡',
  'question_zone': '付费问答'
};

export const payType = {
  '1': '普通订单',
  // '2': '买赠订单',
  '2': '普通订单',
  '5': '积分兑换订单'
};

// 短书版本
export const dsVersion = {
  adv: 'advanced',
  basic: 'basic',
  partner: 'partner',
  unactive_partner: 'unactive_partner'
};

// 公众号认证类型
export const verifyTypeMap = {
  '-1': '未认证',
  '0': '已认证',// 微信认证
  '1': '新浪微博认证',
  '2': '腾讯微博认证',
  '3': '已资质认证通过但还未通过名称认证',
  '4': '已资质认证通过、还未通过名称认证，但通过了新浪微博认证',
  '5': '已资质认证通过、还未通过名称认证，但通过了腾讯微博认证'
};

export const serviceTypeMap = {
  '0': '订阅号',
  // '1': '由历史老帐号升级后的订阅号',
  '1': '订阅号',
  '2': '服务号'
};

// 菜单映射对照
export const menuSlugMap = {
  overview: 'shop',                                 // 店铺概况
  contentList: 'content',                           // 我的内容
  subscriptionArticle: 'wechat_article',            // 公众号文章
  column: 'column',                                 // 我的专栏
  course: 'course',                                 // 我的课程
  offlinecourse: 'offline_course',                  // 在线招生
  contentLive: 'live',                              // 我的直播
  preview: 'preview',                               // 手机预览
  storeinfo: 'shop_config',                         // 店铺设置
  taskCenter: 'task_center',                        // 下载中心
  carousel: 'banner',                               // 轮播导航
  contentCategory: 'content_category',              // 内容分类
  // library: 'library',                               // 素材管理
  material: 'library',                              // 素材管理
  pushset: 'notice',                                // 推送提醒
  addFans: 'increase_fans',                         // 涨粉神器
  message: 'message',                               // 消息管理
  comment: 'comment',                               // 评论管理
  consumed: 'consumecode',                          // 核销验证
  userinfoGathering: 'userinfo_gathering',          // 信息收集
  invitation: 'gifting',                            // 赠送码
  invitationGroup: 'invitation',                    // 群发赠送码
  memberCard: 'member_card',                        // 会员卡
  promoter: 'promotion',                            // 推广员
  purchase: 'flash_sale',                           // 限时购
  community: 'community',                           // 小社群
  pinTuan: 'pintuan',                               // 拼团
  obslive: 'obs_live',                              // OBS直播
  onlinelive: 'online_live',                        // 手机直播
  xiuzanFeedback: 'xiuzan_feedback',                // 表单
  xiuzanSurvey: 'xiuzan_survey',                    // 问卷
  user: 'user',                                     // 我的用户
  order: 'order',                                   // 订单中心
  admire: 'admire',                                 // 直播打赏
  msganalysis: 'content_analysis',                  // 内容分析
  useranalysis: 'user_analysis',                    // 用户分析
  incomeanalysis: 'trade_analysis',                 // 交易分析
  funds: 'fund',                                    // 资产管理
  service: 'service',                               // 服务订购
  accounts: 'account',                              // 账号详情
  character: 'sub_account',                         // 子账号
  noticeCenter: 'notice_center',                    // 通知中心，
  minijump: 'weapp_redirect',                       // 小程序跳转
  storeHideData: 'hide_data',                       // 店铺数据隐藏
  discount: 'coupon',                               // 优惠券
  examManage: 'exam_manage',                        // 题库管理
  exam: 'exam',                                     // 测验
  memberScore: 'member_score',                      // 积分管理
  scoreShop: 'score_store',                         // 积分商城
  card: 'card',                                     // 打卡
  consult: 'question_zone'                          // 付费问答
};

// 子账号权限标识罗列
export const menuPowerMap = [
    'content',
    'subscriptionArticle',
    'column',
    'course',
    'offlinecourse',
    'live',
    'interface',
    'storeinfo',
    'taskCenter',
    'banner',
    'contentCategory',
    'material',
    'pushset',
    'addFans',
    'message',
    'comment',
    'consumed',
    'invitation',
    'invitationGroup',
    'memberCard',
    'promoter',
    'purchase',
    'community',
    'pinTuan',
    'obslive',
    'onlinelive',
    'xiuzanFeedback',
    'xiuzanSurvey',
    'member',
    'order',
    'admire',
    'member_analysis',
    'content_analysis',
    'income_analysis',
    'funds',
    'service',
    'noticeCenter',
    'minijump',
    'storeHideData',
    'userinfo_gathering',
    'discount',
    'storeHideData',
    'userinfoGathering',
    'examManage',
    'exam',
    'invitationGroup',
    'memberScore',
    'scoreShop',
    'card',
    'consult'
];

//菜单权限应该跳转的路由name映射
export const menuPowerNameMap = {
  'content': 'contentGraphics',
  'subscriptionArticle': 'subscriptionArticle',
  'column': 'column',
  'course': 'course',
  'offlinecourse': 'offlinecourse',
  'live': 'contentLive',
  'interface': 'phone',
  'storeinfo': 'storeinfo',
  'taskCenter': 'taskCenter',
  'banner': 'index',
  'contentCategory': 'contentCategory',
  'material': 'picture',
  'pushset': 'pushset',
  'addFans': 'addFans',
  'message': 'notification',
  'comment': 'comment',
  'consumed': 'consumedSearch',
  'invitation': 'invitationGift',
  'invitationGroup': 'invitationGroupList',
  'memberCard': 'memberCard',
  'promoter': 'promoterPerson',
  'purchase': 'purchaseList',
  'community': 'community',
  'pinTuan': 'pinTuan',
  'obslive': 'obslive',
  'onlinelive': 'onlinelive',
  'xiuzanFeedback': 'xiuzanFeedback',
  'xiuzanSurvey': 'xiuzanSurvey',
  'member': 'userList',
  'order': 'order',
  'admire': 'admire',
  'member_analysis': 'useranalysis',
  'content_analysis': 'msganalysis',
  'income_analysis': 'incomeanalysis',
  'funds': 'funds',
  'service': 'service',
  'noticeCenter': 'noticeCenter',
  'minijump': 'minijump',
  'storeHideData': 'storeHideData',
  'examManage': 'examManage',
  'exam': 'exam',
  'memberScore': 'memberScore',
  'scoreShop': 'scoreShop',
  'card': 'card',
  'consult': 'consultManage'
}

// 菜单栏项目对应的分组
export const menuActiveMap = {
  overview: 'overview',         // 店铺概况
  contentList: 'content',       // 我的内容
  column: 'content',            // 我的专栏
  subscriptionArticle: 'content',// 我的专栏
  course: 'course',             // 我的课程
  offlinecourse: 'course',      // 在线招生
  contentLive: 'live',          // 我的直播
  preview: 'mobile',            // 手机预览
  storeinfo: 'mobile',          // 店铺设置
  taskCenter: 'account',        // 任务中心
  carousel: 'operate',          // 轮播导航
  contentCategory: 'operate',   // 内容分类
  library: 'operate',           // 素材管理
  material: 'operate',          // 素材管理
  pushset: 'operate',           // 推送提醒
  addFans: 'operate',           // 推送提醒
  message: 'operate',           // 消息管理
  comment: 'operate',           // 评论管理
  consumed: 'operate',          // 核销验证
  examManage: 'operate',        // 题库管理
  invitation: 'promote',        // 赠送码
  invitationGroup: 'promote',   // 群发赠送码
  memberCard: 'promote',        // 会员卡
  promoter: 'promote',          // 推广员
  purchase: 'promote',          // 限时购
  community: 'promote',         // 小社群
  pinTuan: 'promote',           // 拼团
  obslive: 'promote',           // OBS直播
  onlinelive: 'promote',        // 手机直播
  xiuzanFeedback: 'promote',    // 表单
  xiuzanSurvey: 'promote',      // 问卷
  exam: 'promote',              // 测验
  scoreShop: 'promote',         // 积分商城
  card: 'promote',              // 打卡
  user: 'manage',               // 我的用户
  memberScore: 'manage',        // 积分管理
  order: 'finance',             // 订单中心
  admire: 'promote',            // 直播打赏
  msganalysis: 'statistics',    // 内容分析
  useranalysis: 'statistics',   // 用户分析
  incomeanalysis: 'statistics', // 交易分析
  funds: 'asset',               // 资产管理
  service: 'asset',             // 服务订购
  accounts: 'account',          // 账号详情
  character: 'account',         // 子账号
  noticeCenter: 'account',      // 通知中心
  minijump: 'operate',          // 小程序跳转
  storeHideData: 'operate',     // 店铺数据隐藏
  userinfo_gathering: 'operate',// 信息收集
  discount: 'promote',          // 优惠券
  consult: 'content'            // 付费问答
};



// WEBPACK FOOTER //
// ./src/config/setting.js